import Axios from 'axios';
import { useState } from 'react';

const allowedExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];

const useImageUrlPreview = () => {
  const [isValid, setIsValid] = useState(false);
  const [error, setError] = useState('');
  const [previewUrl, setPreviewUrl] = useState('');
  const [generating, setGenerating] = useState(false);

  const isUrl = (url: string) => {
    const REGEX = /^(https?|ftp)(:\/\/[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#]+)$/;
    return url.match(REGEX);
  };

  const isAllowedFileExtensions = (extensions: string) => {
    return allowedExtensions.includes(extensions);
  };

  const generatePreviewUrl = async (url: string) => {
    setGenerating(true);
    try {
      const extension = url.match(/[^.]+$/);

      if (!isUrl(url)) {
        throw new Error('有効なURLを入力してください。');
      }
      if (extension === null) {
        throw new Error('予期せぬエラーが発生しました。');
      }
      if (!isAllowedFileExtensions(extension[0])) {
        throw new Error(`${allowedExtensions.join(', ')}拡張子のみ有効です`);
      }
      await Axios({
        url: url,
        method: 'get',
        responseType: 'blob',
      })
        .then((response) => {
          const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
          setPreviewUrl(blobUrl);
          setIsValid(true);
          setError('');
        })
        .catch(() => {
          throw new Error(`画像の読み込みに失敗しました。`);
        });
    } catch (error) {
      if (error instanceof Error) {
        setError(error.message);
        setPreviewUrl('');
        setIsValid(false);
      } else {
        setError('予期せぬエラーが発生しました。');
        setPreviewUrl('');
        setIsValid(false);
      }
    } finally {
      setGenerating(false);
    }
  };

  const reset = () => {
    setPreviewUrl('');
    setIsValid(false);
    setError('');
  };

  return { previewUrl, generating, isValid, error, generatePreviewUrl, reset };
};

export default useImageUrlPreview;
